import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
`;

export const AirplaneContainer = styled.div`
  position: absolute;
  width: 3px;
  height: 3px;
  transform-origin: center center;
  color: #007ade;
  transition: opacity 0.3s ease;
  will-change: transform;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
`;

export const ConfettiPiece = styled.div`
  position: absolute;
  width: 8px;
  height: 8px;
  transform-origin: center center;
  will-change: transform;
  border-radius: 2px;
`;
